/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Notitietype_Beweegresultaat3Inputs */

const nl_enums_notitietype_beweegresultaat3 = /** @type {(inputs: Enums_Notitietype_Beweegresultaat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beweegresultaat`)
};

/**

* @param {Enums_Notitietype_Beweegresultaat3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_notitietype_beweegresultaat3 = /** @type {((inputs?: Enums_Notitietype_Beweegresultaat3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Notitietype_Beweegresultaat3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_notitietype_beweegresultaat3(inputs)
});
export { enums_notitietype_beweegresultaat3 as "enums.NotitieType.Beweegresultaat" }